<template>  
  <div ref="orderModalRef" class="modal fade" id="orderModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true" translate="no">
    <div class="modal-dialog modal-lg modal-fullscreen-sm-down modal-dialog-scrollable my-0">
      <div class="modal-content border-0 rounded-0">
        <!-- header -->
        <div class="modal-header h-42 py-0 px-3 lh-1 border-0 btn bg-primary-subtle primary-mix-black-10 rounded-0" type="button" data-bs-dismiss="modal" aria-label="Close">
          <svg width="28" height="28"><use xlink:href="#back"/></svg>
        </div>
        <div class="modal-body py-0">
          <!-- form -->
          <form class="px-2">
            <div class="row g-0 align-items-center my-3 iconInput">
              <div class="col-auto me-3">
                <label for="Date" class="col-form-label">
                  <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#date"/></svg>
                </label>
              </div>
              <div class="col form-floating">
                <input v-model="form.Date" type="date" class="form-control" id="Date" placeholder="Date">
                <label for="Date">訂單日期</label>
              </div>
            </div>

            <!-- 訂購資訊 -->
            <div class="d-flex align-items-center mt-4 mb-3 mx-n4">
              <span class="flex-grow-1 border-5 border-top border-light-subtle me-2"></span>
              <b class="small text-secondary">訂購資訊</b>
              <span class="flex-grow-1 border-5 border-top border-light-subtle ms-2"></span>
            </div>

            <div class="row g-0 align-items-center mb-3 iconInput">
              <div class="col-auto me-3">
                <label for="OrderId" class="col-form-label">
                  <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#title"/></svg>
                </label>
              </div>
              <div class="col form-floating">
                <input v-model="form.OrderId" type="text" class="form-control" id="OrderId" placeholder="Order Id">
                <label for="OrderId">訂單編號</label>
              </div>
            </div>

            <div class="row g-0 align-items-center mb-3 iconInput">
              <div class="col-auto me-3">
                <label for="Provider" class="col-form-label">
                  <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#store"/></svg>
                </label>
              </div>
              <div class="col form-floating">
                <AutoComplete 
                  :options="(storeSearchResults || []).map(result => result.store_name)"
                  :initialValue="form.Provider"
                  @selected="handleStoreSelected"
                  @input="handleStoreInput"
                  @focus="onProviderFocus"
                />
                <label for="Provider">商店名稱</label>
              </div>
            </div>

            <div class="row g-0 align-items-center mb-3 iconInput">
              <div class="col-auto me-3">
                <label for="Item" class="col-form-label">
                  <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#gift"/></svg>
                </label>
              </div>
              <div class="col form-floating">
                <textarea 
                  v-model="form.Item" 
                  class="form-control auto-expand px-0" 
                  id="Item" 
                  placeholder="Item" 
                  rows="1"
                  ref="itemTextarea"
                  @input="adjustTextareaHeight"
                ></textarea>
                <label for="Item" class="lh-1">商品名稱</label>
              </div>
            </div>

            <div class="d-flex">
              <div class="p-2 ms-4"></div>
              <div class="flex-grow-1 row row-cols-2">

                <div class="col mb-3">
                  <div class="form-floating iconInput">
                    <input v-model="form.Accounts" type="text" inputmode="numeric" class="form-control" id="Accounts" placeholder="Accounts">
                    <label for="Accounts">金額</label>
                  </div>
                </div>

                <div class="col mb-3">
                  <div class="form-floating iconInput">
                    <input v-model="form.Amounts" type="text" inputmode="numeric" class="form-control" id="Amounts" placeholder="Amounts">
                    <label for="Amounts">數量</label>
                  </div>
                </div>

              </div>

            </div>

            <div class="row g-0 align-items-center mb-3 iconInput">
              <div class="col-auto me-3">
                <label for="Total" class="col-form-label">
                  <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#money-pack"/></svg>
                </label>
              </div>
              
              <div class="col d-flex">
                <div class="flex-grow-1 row row-cols-2">
                  <div class="col mb-3">
                    <div class="form-floating iconInput">
                      <input v-model="form.Total" type="text" inputmode="numeric" class="form-control" id="Total" placeholder="Total">
                      <label for="Total">總計金額</label>
                    </div>
                  </div>

                  <div class="col mb-3">
                    <div class="form-floating iconInput">
                      <!-- <input v-model="form.PaidTotal" type="text" inputmode="numeric" class="form-control" id="PaidTotal" placeholder="PaidTotal" :disabled="(displayedIBVPercent > 0 || form.IBV > 0) && !(form.BV > 0 || form.BVProfit > 0)"> -->
                      <input v-model="form.PaidTotal" type="text" inputmode="numeric" class="form-control" id="PaidTotal" placeholder="PaidTotal">
                      <label for="PaidTotal">成本價格</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row g-0 align-items-center mb-3 iconInput">
              <div class="col-auto me-3">
                <label for="Payment" class="col-form-label">
                  <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#wallet"/></svg>
                </label>
              </div>
              <div class="col form-floating">
                <select v-model="form.Payment" class="form-select" id="Payment" aria-label="Payment">
                  <option value="現金匯款">現金匯款</option>
                  <option value="信用卡">信用卡</option>
                  <option value="LINE PAY">LINE PAY</option>
                  <option value="其它電子支付">其它電子支付</option>
                </select>
                <label for="Payment">繳費方式</label>
              </div>
            </div>

            <div class="row g-0 align-items-center mb-3 iconInput">
              <div class="col-auto me-3">
                <label for="Paid" class="col-form-label">
                  <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#pay"/></svg>
                </label>
              </div>
              <div class="col"><label for="Paid">是否付款</label></div>
              <div class="col-auto form-check form-switch">
                <input v-model="paidChecked" class="form-check-input" type="checkbox" role="switch" id="Paid">
              </div>
            </div>

            <div class="row g-0 align-items-center mb-3 iconInput">
              <div class="col-auto me-3">
                <label for="Arrived" class="col-form-label">
                  <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#truck"/></svg>
                </label>
              </div>
              <div class="col"><label for="Arrived">是否到貨</label></div>
              <div class="col-auto form-check form-switch">
                <input v-model="arrivedChecked" class="form-check-input" type="checkbox" role="switch" id="Arrived">
              </div>
            </div>

            <!-- IBV/BV -->
            <div class="d-flex align-items-center mt-4 mb-3 mx-n4">
              <span class="flex-grow-1 border-5 border-top border-light-subtle me-2"></span>
              <b class="small text-secondary">IBV/BV</b>
              <span class="flex-grow-1 border-5 border-top border-light-subtle ms-2"></span>
            </div>

            <div class="row row-cols-2">

              <div class="col mb-3">
                <div class="col form-floating iconInput percentage-form">
                  <!-- <input v-model="displayedIBVPercent" type="text" inputmode="decimal" class="form-control" id="IBVPercent" placeholder="IBVPercent" :disabled="(form.BV > 0 || form.BVProfit > 0) && !(displayedIBVPercent > 0 || form.IBV > 0)"> -->
                  <input v-model="displayedIBVPercent" type="text" inputmode="decimal" class="form-control" id="IBVPercent" placeholder="IBVPercent">
                  <span>%</span>
                  <label for="IBVPercent">IBV%</label>
                </div>
              </div>

              <div class="col mb-3">
                <div class="form-floating iconInput" :class="{ 'checked-form': form.Modified }">
                  <!-- <input v-model="form.IBV" type="text" inputmode="decimal" class="form-control" id="IBV" placeholder="IBV" :class="{ 'bg-success bg-opacity-10': form.Modified }"
                  :disabled="(form.BV > 0 || form.BVProfit > 0) && !(displayedIBVPercent > 0 || form.IBV > 0)"> -->
                  <input v-model="form.IBV" type="text" inputmode="decimal" class="form-control" id="IBV" placeholder="IBV" :class="{ 'bg-success bg-opacity-10': form.Modified }">
                  <span v-if="form.Modified"><svg class="text-success" width="24" height="24"><use xlink:href="#check-circle"/></svg></span>
                  <label for="IBV">IBV點數</label>
                </div>
              </div>

              <div class="col mb-3">
                <div class="col form-floating iconInput">
                  <!-- <input v-model="form.BVProfit" type="text" inputmode="numeric" class="form-control" id="BVProfit" placeholder="BVProfit" :disabled="(displayedIBVPercent > 0 || form.IBV > 0) && !(form.BV > 0 || form.BVProfit > 0)"> -->
                  <input v-model="form.BVProfit" type="text" inputmode="numeric" class="form-control" id="BVProfit" placeholder="BVProfit" :disabled=true>
                  <label for="BVProfit">零售利潤（價差）</label>
                </div>
              </div>

              <div class="col mb-3">
                <div class="col form-floating iconInput">
                  <!-- <input v-model="form.BV" type="text" inputmode="decimal" class="form-control" id="BV" placeholder="BV" :disabled="(displayedIBVPercent > 0 || form.IBV > 0) && !(form.BV > 0 || form.BVProfit > 0)"> -->
                  <input v-model="form.BV" type="text" inputmode="decimal" class="form-control" id="BV" placeholder="BV">
                  <label for="BV">BV點數</label>
                </div>
              </div>

            </div>

            <!-- 現金回饋（Lab 功能） -->
            <div v-if="isLabUser && ((selectedStoreCashback.cashback || selectedStoreCashback.cb_ibv) || (form.Cashback || form.CbIbv || form.CashbackPercent || form.CbIbvPercent))" class="d-flex align-items-center mt-4 mb-3 mx-n4">
              <span class="flex-grow-1 border-5 border-top border-light-subtle me-2"></span>
              <b class="small text-secondary">現金回饋</b>
              <span class="flex-grow-1 border-5 border-top border-light-subtle ms-2"></span>
            </div>

            <div v-if="isLabUser && ((selectedStoreCashback.cashback || selectedStoreCashback.cb_ibv) || (form.Cashback || form.CbIbv || form.CashbackPercent || form.CbIbvPercent))" class="row row-cols-2">

              <div v-if="selectedStoreCashback.cashback || form.Cashback || form.CashbackPercent" class="col mb-3">
                <div class="col form-floating iconInput percentage-form">
                  <input :value="selectedStoreCashback.cashback || (form.CashbackPercent ? form.CashbackPercent + '%' : '')" type="text" class="form-control" id="CashbackPercent" placeholder="CashbackPercent" disabled>
                  <span>%</span>
                  <label for="CashbackPercent">現金回饋%</label>
                </div>
              </div>

              <div v-if="selectedStoreCashback.cashback || form.Cashback || form.CashbackPercent" class="col mb-3">
                <div class="form-floating iconInput">
                  <input :value="calculatedCashbackAmount || form.Cashback" type="text" class="form-control" id="CashbackAmount" placeholder="CashbackAmount" disabled>
                  <label for="CashbackAmount">現金回饋金額</label>
                </div>
              </div>

              <div v-if="selectedStoreCashback.cb_ibv || form.CbIbv || form.CbIbvPercent" class="col mb-3">
                <div class="col form-floating iconInput percentage-form">
                  <input :value="selectedStoreCashback.cb_ibv || (form.CbIbvPercent ? form.CbIbvPercent + '%' : '')" type="text" class="form-control" id="CbIbvPercent" placeholder="CbIbvPercent" disabled>
                  <span>%</span>
                  <label for="CbIbvPercent">CB IBV%</label>
                </div>
              </div>

              <div v-if="selectedStoreCashback.cb_ibv || form.CbIbv || form.CbIbvPercent" class="col mb-3">
                <div class="form-floating iconInput">
                  <input :value="calculatedCbIbvAmount || form.CbIbv" type="text" class="form-control" id="CbIbvAmount" placeholder="CbIbvAmount" disabled>
                  <label for="CbIbvAmount">CB IBV 點數回饋</label>
                </div>
              </div>

            </div>

            <!-- 聯絡資訊 -->
            <div class="d-flex align-items-center mt-4 mb-3 mx-n4">
              <span class="flex-grow-1 border-5 border-top border-light-subtle me-2"></span>
              <b class="small text-secondary">聯絡資訊</b>
              <span class="flex-grow-1 border-5 border-top border-light-subtle ms-2"></span>
            </div>

            <div class="row g-0 align-items-center mb-3 iconInput">
              <div class="col-auto me-3">
                <label for="Customer" class="col-form-label">
                  <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#customer"/></svg>
                </label>
              </div>
              <div class="col form-floating">
                <AutoComplete 
                  ref="customerAutoComplete"
                  :options="contacts.map(contact => contact.Customer)" 
                  :initialValue="form.Customer" 
                  @selected="handleCustomerSelected" 
                  @input="handleCustomerInput"
                  @focus="onCustomerFocus"
                  :disabled="personalUseChecked"/>
                <label for="Customer">客戶姓名 <b class="text-danger">*</b></label>
              </div>
              <div class="col-auto ms-2 d-flex gap-1 align-items-center">
                <label for="PersonalUse">自用</label>
                <div class="col-auto form-check form-switch">
                  <input v-model="personalUseChecked" class="form-check-input" type="checkbox" role="switch" id="PersonalUse">
                </div>
              </div>
            </div>

            <div class="row g-0 align-items-center mb-3 iconInput">
              <div class="col-auto me-3">
                <label for="Customer_phone" class="col-form-label">
                  <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#phone"/></svg>
                </label>
              </div>
              <div class="col form-floating">
                <input v-model="form.CustPhone" type="tel" class="form-control" id="Customer_phone" placeholder="Phone">
                <label for="Customer_phone">客戶電話</label>
              </div>
            </div>

            <div class="row g-0 align-items-center mb-3 iconInput">
              <div class="col-auto me-3">
                <label for="Email" class="col-form-label">
                  <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#mail"/></svg>
                </label>
              </div>
              <div class="col form-floating">
                <input v-model="form.Email" type="email" class="form-control" id="Email" placeholder="Email">
                <label for="Email">Email</label>
              </div>
            </div>

            <div class="row g-0 align-items-center mb-3 iconInput">
              <div class="col-auto me-3">
                <label for="Recipient" class="col-form-label">
                  <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#recipient"/></svg>
                </label>
              </div>
              <div class="col form-floating">
                <input v-model="form.Recipient" type="text" class="form-control" id="Recipient" placeholder="Recipient">
                <label for="Recipient">收件人姓名</label>
              </div>
            </div>

            <div class="row g-0 align-items-center mb-3 iconInput">
              <div class="col-auto me-3">
                <label for="Recipient_phone" class="col-form-label">
                  <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#recipient-call"/></svg>
                </label>
              </div>
              <div class="col form-floating">
                <input v-model="form.Phone" type="tel" class="form-control" id="Recipient_phone" placeholder="Phone">
                <label for="Recipient_phone">收件電話</label>
              </div>
            </div>

            <div class="row g-0 align-items-center mb-3 iconInput">
              <div class="col-auto me-3">
                <label for="Addr" class="col-form-label">
                  <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#address"/></svg>
                </label>
              </div>
              <div class="col form-floating">
                <AutoComplete
                :options="addrList" 
                :initialValue="form.Addr" 
                @selected="handleSelected" 
                @input="handleInput"
                @focus="onAddrFocus"
                ref="autoComplete"/>
                <label for="Addr">收件地址</label>
              </div>
            </div>

            <div class="row align-items-center mb-3">

            <div class="col d-flex align-items-center iconInput">
              <div class="flex-shrink-1 me-3">
                <label for="Carrier" class="col-form-label">
                  <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#receipt"/></svg>
                </label>
              </div>
              <div class="w-100 form-floating">
                <input v-model="form.Carrier" type="text" class="form-control" id="Carrier" placeholder="Carrier">
                <label for="Carrier">手機條碼</label>
              </div>
            </div>

            <div class="col d-flex align-items-center iconInput">
              <div class="flex-shrink-1 me-3">
                <label for="TaxIDNumber" class="col-form-label">
                  <svg class="bi pe-none mb-1" width="21" height="21"><use xlink:href="#company"/></svg>
                </label>
              </div>
              <div class="w-100 form-floating">
                <input v-model="form.TaxId" type="text" inputmode="numeric" class="form-control" id="TaxIDNumber" placeholder="tax ID number">
                <label for="TaxIDNumber">統編</label>
              </div>
            </div>

            </div>

            <!-- 備註 -->
            <div class="d-flex align-items-center mt-4 mb-3 mx-n4">
              <span class="flex-grow-1 border-5 border-top border-light-subtle me-2"></span>
              <b class="small text-secondary">備註</b>
              <span class="flex-grow-1 border-5 border-top border-light-subtle ms-2"></span>
            </div>
            <textarea ref="textarea" rows="3" v-model="form.Memo" id="memo" class="form-control px-0" placeholder="在此輸入您的筆記..."></textarea>

          </form>
          <div class="my-3">
            <button v-if="orderModalType == 'update'" :disabled="isLoading" class="btn btn-outline-danger w-100 h-48"
            @click="handleDel">
              <svg class="bi pe-none mb-1 me-1" width="21" height="21"><use xlink:href="#delete"/></svg>
              刪除訂單
            </button>
          </div>
        </div>

        <div class="modal-footer">
          <button :disabled="isLoading || !form.Customer" class="btn btn-primary text-white w-100 h-48" data-bs-dismiss="modal" v-if="orderModalType == 'add' || orderModalType == 'copy'" @click="handleAdd">
            <svg class="bi pe-none mb-1 me-1" width="24" height="24"><use xlink:href="#add"/></svg>
            <b>新增</b>
          </button>
          <button :disabled="isLoading" class="btn btn-primary text-white w-100 h-48" data-bs-dismiss="modal" v-if="orderModalType == 'update' && !isReadOnly" @click="handleUpdate">
            <svg class="bi pe-none mb-1 me-1" width="21" height="21"><use xlink:href="#renew"/></svg>
            <b>更新</b>
          </button>
          <!-- 只讀模式提示 -->
          <div v-if="isReadOnly" class="w-100 text-center py-2 text-muted small">
            <svg class="bi pe-none me-1" width="16" height="16"><use xlink:href="#lock"/></svg>
            此訂單僅供查看，無法編輯
          </div>
          <!-- <button :disabled="isLoading" class="btn btn-light w-100 h-48" aria-label="Close" data-bs-dismiss="modal"
          @click="cancel">取消</button> -->
        </div>
      </div>
    </div>
  </div>

  <ConfirmModal ref="confirmModalRef"
  :title="form.OrderId ? `確定要刪除訂單 ${form.OrderId} 嗎？` : '確定要刪除訂單嗎？'"
  @confirm="$emit('del', form)"
  />

</template>

<script>
/* eslint-disable */
import { reactive, ref, watchEffect, onMounted, onUnmounted, watch, nextTick, computed } from 'vue';
import { Modal } from 'bootstrap';
import ConfirmModal from '@/components/ConfirmModal.vue';
import axios from 'axios';
import AutoComplete from '@/components/AutoComplete.vue';
import liff from '@line/liff';
import debounce from 'lodash.debounce';

let liff_callback = process.env.VUE_APP_LIFF_CALLBACK;

let api_url = process.env.VUE_APP_API_URL;

export default {
  name: 'OrderModal',
  emits: ['add', 'update', 'del', 'cancel', 'fetchAutoCompleteData'],
  components: {
    ConfirmModal,
    AutoComplete
  },
  props: {
    order: {
      type: Object,
      default: () => ({})
    },
    addrList: {
      type: Array,
      default: () => ([])
    },
    contacts: {
      type: Array,
      default: () => ([])
    }
  },
  setup(props, { emit }) {

    const confirmModalRef = ref(null);

    const storeSearchResults = ref([]);
    const searchCache = ref({});
    const autoComplete = ref(null);
    const customerAutoComplete = ref(null);
    const personalUseChecked = ref(false);
    const shouldAutoFillOnContactsUpdate = ref(false); // 新增標記
    const selectedStoreCashback = ref({ cashback: null, cb_ibv: null }); // 存儲選中商店的現金回饋資訊
    const isLabUser = ref(false); // 是否為 Lab 用戶（可使用實驗功能）

    //TODO: 訂單資料表
    const initialFormState = {
      Id: "",
      OrderId: "",
      Date: "",
      Customer: "",
      Email: "",
      CustPhone: "",
      Recipient: "",
      Phone: "",
      Addr: "",
      Item: "",
      Provider: "",
      Amounts: "",
      Total: "",
      PaidTotal: "",
      Accounts: "",
      Payment: "",
      Paid: "",
      Arrived: "",
      IBV: "",
      IBVPercent: "",
      BV: "",
      BVProfit: "",
      Memo: "",
      Carrier: "",
      TaxId: "",
      Modified: "",
      Cashback: "",
      CashbackPercent: "",
      CbIbv: "",
      CbIbvPercent: ""
    };

    const usdPrice = ref(null);
    const isFormLoaded = ref(false);
    const isReadOnly = ref(false); // 新增：只讀模式標記
    const orderModalRef = ref(null);
    let orderModalInstance = null;
    let orderModalType = ref('add');

    const form = reactive({ ...initialFormState });

    const itemTextarea = ref(null);
    // 自動調整商品名稱欄位高度
    const adjustTextareaHeight = () => {
      nextTick(() => {
        const textarea = itemTextarea.value;
        if (textarea) {
          textarea.style.height = 'auto';
          textarea.style.height = `${textarea.scrollHeight}px`;
        }
      });
    };

    onMounted(async () => {
      // Instantiate the modal with the ref
      if (orderModalRef.value) {

        orderModalInstance = new Modal(orderModalRef.value);

        orderModalRef.value.addEventListener('hidden.bs.modal', function (e) {
          emit('cancel');
          closeModal();
        });

        orderModalRef.value.addEventListener('shown.bs.modal', () => {
          nextTick(() => {
            adjustTextareaHeight();
          });
        });

      } else {
        console.log("Modal instance can't be initialized.");
      }

      // 異步獲取匯率，不阻塞組件載入
      try {
        usdPrice.value = await get_usd_price();
      } catch (error) {
        console.error('Failed to load USD price, using default:', error);
        usdPrice.value = 32.0;
      }

    });

    onUnmounted(() => {
      // Cleanup the modal instance if necessary
      if (orderModalInstance) {
        orderModalInstance?.dispose();
      }
    });

    const resetForm = () => {
      Object.assign(form, initialFormState);
      // 清空商店現金回饋資訊，避免殘留影響下一筆訂單
      selectedStoreCashback.value = { cashback: null, cb_ibv: null };
    };
    
    const cancel = () => {
      emit('cancel');
      closeModal();
    };

    let stopWatchTotal = null;
    let stopWatchIBVPercent = null;
    let stopWatchAmounts = null;
    let stopWatchPaidTotal = null;
    let stopWatchPaidTotal_2 = null;
    let stopWatchBVProfit = null;
    let stopWatchIBV = null;
    let stopWatchPersonalUse = null;
    let stopWatchContacts = null;

    const openModal = async (order_modal_type, selectedOrder, readOnly = false) => {
      orderModalType.value = order_modal_type;
      isReadOnly.value = readOnly; // 設置只讀模式
      // Check liff status
      if (!liff.isLoggedIn()) {
        liff.login({ redirectUri: `${liff_callback}?page=${this.$route.query.page}` });
        return;
      }

      // 檢查用戶是否有 Lab 訪問權限
      const context = liff.getContext();
      if (context && context.userId) {
        await checkLabAccess(context.userId);
      }

      // Use the bootstrap modal method to show it
      if (orderModalInstance) {
        orderModalInstance.show();

        initForm();

        nextTick (() => {

          // 監控 IBV 變化
          stopWatchIBV = watch(() => form.IBV, (newIBV, oldIBV) => {
            // 判斷 IBV 是否有變化而且 focus 在 IBV 欄位
            if (newIBV !== oldIBV && document.activeElement.id === 'IBV') {
              if (newIBV === "") {
                form.Modified = false;
              } else {
                form.Modified = true;
              }
              
            }
          });

          // 監控 PaidTotal 變化
          stopWatchPaidTotal_2 = watch(() => form.PaidTotal, (newTotal, oldTotal) => {
            if (!form.Modified && usdPrice.value && isFormLoaded.value) {
              if (Number(form.PaidTotal) !== 0 && Number(form.IBVPercent) !== 0) {
                form.IBV = (Number(newTotal) || 0) * (Number(form.IBVPercent) || 0) / usdPrice.value;
                form.IBV = Number(form.IBV.toFixed(2));
              } else {
                form.IBV = "";
              }
            }
          });

          // 監控 IBVPercent 變化
          stopWatchIBVPercent = watch(() => form.IBVPercent, (newIBVPercent, oldIBVPercent) => {
            if (!form.Modified && usdPrice.value && isFormLoaded.value) {
              if (Number(form.PaidTotal) !== 0  && Number(newIBVPercent) !== 0) {
                form.IBV = (Number(form.PaidTotal) || 0) * (Number(newIBVPercent) || 0) / usdPrice.value;
                form.IBV = Number(form.IBV.toFixed(2));
              } else {
                form.IBV = "";
              }
            }
          });

          // 監控 Amounts, Accounts 變化
          stopWatchAmounts = watch(() => [form.Amounts, form.Accounts], () => {
            if (Number(form.Amounts) !== 0 && Number(form.Accounts) !== 0) {
              form.Total = Number(form.Amounts) * Number(form.Accounts);
              form.PaidTotal = form.Total;
              form.BVProfit = Number(form.Total) - Number(form.PaidTotal);
              form.BVProfit = Number(form.Total || 0) - Number(form.PaidTotal || 0);
            } 
          });

          // 監控 Total, PaidTotal 變化
          stopWatchPaidTotal = watch(() => [form.Total, form.PaidTotal], () => {

            if (Number(form.Total) !== 0 && Number(form.Amounts) !== 0) {
              form.Accounts = Number(form.Total) / Number(form.Amounts);
            }

            if (form.Total !== "" && form.Total !== null && form.PaidTotal !== "" && form.PaidTotal !== null) {
              form.BVProfit = Number(form.Total) - Number(form.PaidTotal);
            } else {
              form.BVProfit = Number(form.Total || 0) - Number(form.PaidTotal || 0);
            }
          });

          // 監控 BVProfit 變化
          /* stopWatchBVProfit = watch(() => form.BVProfit, () => {
            if (form.Total !== "" && form.Total !== null && form.BVProfit !== "" && form.BVProfit !== null) {
              form.PaidTotal = Number(form.Total) - Number(form.BVProfit);
            } else {
              form.PaidTotal = Number(form.Total || 0) - Number(form.BVProfit || 0);
}
          }); */

          stopWatchPersonalUse = watch(personalUseChecked, (val) => {
            if (val) {
              console.log('切換自用開關，當前 contacts:', props.contacts); // 調試用
              form.Customer = '自己';
              
              // 設置標記，表示需要在 contacts 更新時自動填入
              shouldAutoFillOnContactsUpdate.value = true;
              
              // 觸發獲取 contacts 資訊，就像手動輸入時一樣
              emit('fetchAutoCompleteData');
              
              nextTick(() => {
                autoFill('自己');
                // 確保 AutoComplete 組件顯示正確的值
                updateAutoCompleteValue('自己');
              });
            } else {
              form.Customer = '';
              shouldAutoFillOnContactsUpdate.value = false; // 清除標記
              // 清空相關欄位
              form.CustPhone = '';
              form.Email = '';
              form.Recipient = '';
              form.Phone = '';
              form.Addr = '';
              form.Carrier = '';
              form.TaxId = '';
              nextTick(() => {
                // 清空 AutoComplete 組件顯示
                updateAutoCompleteValue('');
              });
            }
          });

          // 監聽 contacts 變化，只有在標記為 true 時才執行自動填入
          stopWatchContacts = watch(() => props.contacts, (newContacts) => {
            if (shouldAutoFillOnContactsUpdate.value && 
                personalUseChecked.value && 
                form.Customer === '自己' && 
                newContacts && 
                newContacts.length > 0) {
              console.log('contacts 載入完成，重新執行自動填入:', newContacts);
              autoFill('自己');
              shouldAutoFillOnContactsUpdate.value = false; // 執行完畢後清除標記
            }
          }, { deep: true });

          isFormLoaded.value = true;


        });

      } else {
        console.error('Modal instance is not initialized.');
      }
    };

    const closeModal = () => {

      if (typeof stopWatchTotal === 'function') {
        stopWatchTotal();
        stopWatchTotal = null;
      }
      if (typeof stopWatchIBVPercent === 'function') {
        stopWatchIBVPercent();
        stopWatchIBVPercent = null;
      }
      if (typeof stopWatchAmounts === 'function') {
        stopWatchAmounts();
        stopWatchAmounts = null;
      }
      if (typeof stopWatchPaidTotal === 'function') {
        stopWatchPaidTotal();
        stopWatchPaidTotal = null;
      }
      if (typeof stopWatchPaidTotal_2 === 'function') {
        stopWatchPaidTotal_2();
        stopWatchPaidTotal_2 = null;
      }
      if (typeof stopWatchBVProfit === 'function') {
        stopWatchBVProfit();
        stopWatchBVProfit = null;
      }
      if (typeof stopWatchIBV === 'function') {
        stopWatchIBV();
        stopWatchIBV = null;
      }
      if (typeof stopWatchPersonalUse === 'function') {
        stopWatchPersonalUse();
        stopWatchPersonalUse = null;
      }
      if (typeof stopWatchContacts === 'function') {
        stopWatchContacts();
        stopWatchContacts = null;
      }

      isFormLoaded.value = false;
      // 清空商店現金回饋資訊，避免影響下一次開啟
      selectedStoreCashback.value = { cashback: null, cb_ibv: null };
      orderModalInstance?.hide();

    };

    const handleAdd = () => {
      // 只有在有選擇商店時才更新現金回饋資訊，避免覆蓋手動編輯的值
      if (selectedStoreCashback.value.cashback) {
        form.CashbackPercent = parseFloat(selectedStoreCashback.value.cashback.replace('%', ''));
        if (calculatedCashbackAmount.value !== null) {
          form.Cashback = calculatedCashbackAmount.value;
        }
      }
      if (selectedStoreCashback.value.cb_ibv) {
        form.CbIbvPercent = parseFloat(selectedStoreCashback.value.cb_ibv.replace('%', ''));
        if (calculatedCbIbvAmount.value !== null) {
          form.CbIbv = calculatedCbIbvAmount.value;
        }
      }
      emit('add', form);
      closeModal();
    };

    const handleUpdate = () => {
      // 只有在有選擇商店時才更新現金回饋資訊，避免覆蓋手動編輯的值
      if (selectedStoreCashback.value.cashback) {
        form.CashbackPercent = parseFloat(selectedStoreCashback.value.cashback.replace('%', ''));
        if (calculatedCashbackAmount.value !== null) {
          form.Cashback = calculatedCashbackAmount.value;
        }
      }
      if (selectedStoreCashback.value.cb_ibv) {
        form.CbIbvPercent = parseFloat(selectedStoreCashback.value.cb_ibv.replace('%', ''));
        if (calculatedCbIbvAmount.value !== null) {
          form.CbIbv = calculatedCbIbvAmount.value;
        }
      }
      emit('update', form);
      closeModal();
    };

    const handleDel = () => {
      confirmModalRef.value.openModal();
    };

    const get_usd_price = async () => {
      try {
        const baseURL = `${api_url}/v1/t/usd-selling-rate`;
        const response = await axios.get(baseURL, {
          headers: {
            "ngrok-skip-browser-warning": "69420"
          }
        });
        return response.data;
      } catch (error) {
        console.error('Error fetching USD rate:', error);
        // 回傳預設匯率，避免影響 UI
        return 32.0;
      }
    }

    const checkLabAccess = async (userId) => {
      try {
        const idToken = liff.getIDToken();
        const response = await axios.get(`${api_url}/v1/users/${userId}/check_lab_access`, {
          headers: {
            "ngrok-skip-browser-warning": "69420",
            "Authorization": `Bearer ${idToken}`
          }
        });
        isLabUser.value = response.data.is_lab_user || false;
      } catch (error) {
        console.error('Error checking lab access:', error);
        isLabUser.value = false;
      }
    }

    const handleSelected = (newValue) => {
      if (form.Addr !== newValue) {
        form.Addr = newValue;
      }
      fetchPostalCode(newValue)
    }

    const handleInput = (newValue) => {
      form.Addr = newValue;
      fetchPostalCode(newValue)
    }

    const updateAutoCompleteValue = (value) => {
      try {
        if (!customerAutoComplete.value) return;
        
        // 嘗試多種方式獲取 input 元素
        let inputElement = null;
        
        // 方式 1: 通過 $el 查詢
        if (customerAutoComplete.value.$el && typeof customerAutoComplete.value.$el.querySelector === 'function') {
          inputElement = customerAutoComplete.value.$el.querySelector('input');
        }
        
        // 方式 2: 直接通過 inputRef 屬性
        if (!inputElement && customerAutoComplete.value.inputRef) {
          inputElement = customerAutoComplete.value.inputRef;
        }
        
        // 方式 3: 通過 $refs
        if (!inputElement && customerAutoComplete.value.$refs && customerAutoComplete.value.$refs.input) {
          inputElement = customerAutoComplete.value.$refs.input;
        }
        
        // 方式 4: 嘗試找到第一個 input 元素
        if (!inputElement && customerAutoComplete.value.$el) {
          const inputs = customerAutoComplete.value.$el.querySelectorAll ? 
                        customerAutoComplete.value.$el.querySelectorAll('input') : [];
          if (inputs.length > 0) {
            inputElement = inputs[0];
          }
        }
        
        // 如果找到 input 元素，更新其值
        if (inputElement) {
          inputElement.value = value;
          // 觸發 input 事件以確保組件內部狀態同步
          inputElement.dispatchEvent(new Event('input', { bubbles: true }));
        } else {
          console.log('無法找到 AutoComplete 的 input 元素');
        }
      } catch (error) {
        console.error('更新 AutoComplete 值時出錯:', error);
      }
    }

    const autoFill = (newValue) => {
      // 先從 contacts 中尋找完全匹配的客戶
      let contact = props.contacts.find(contact => contact.Customer === newValue);
      
      // 如果沒找到且是「自己」，嘗試尋找其他可能的匹配
      if (!contact && newValue === '自己') {
        // 尋找客戶姓名包含「自己」或「我」的記錄
        contact = props.contacts.find(contact => 
          contact.Customer && (
            contact.Customer.includes('自己') || 
            contact.Customer.includes('我') ||
            contact.Customer === '自己' ||
            contact.Customer === '我'
          )
        );
        
        // 如果還是沒找到，尋找收件人是「自己」或「我」的記錄
        if (!contact) {
          contact = props.contacts.find(contact => 
            contact.Recipient && (
              contact.Recipient.includes('自己') || 
              contact.Recipient.includes('我') ||
              contact.Recipient === '自己' ||
              contact.Recipient === '我'
            )
          );
        }
      }
      
      if (contact) {
        console.log('找到聯絡資訊:', contact); // 調試用
        form.CustPhone = contact.CustPhone || '';
        form.Email = contact.Email || '';
        form.Recipient = contact.Recipient || '';
        form.Phone = contact.Phone || '';
        form.Addr = contact.Addr || '';
        form.Carrier = contact.Carrier || '';
        form.TaxId = contact.TaxId || '';
      } else {
        console.log('未找到聯絡資訊，設置預設值'); // 調試用
      }
    }

    const handleCustomerSelected = (newValue) => {
      form.Customer = newValue;
      autoFill(newValue);
    }

    const handleCustomerInput = (newValue) => {
      form.Customer = newValue;
    }

    const initForm = () => {
      // 每次初始化表單時都清空商店現金回饋資訊
      selectedStoreCashback.value = { cashback: null, cb_ibv: null };
      
      if (orderModalType.value === 'add') {
        // 如果是純粹的新增操作，重置表單
        resetForm();
      } else if (orderModalType.value === 'copy') {
        // 如果是複製操作，保留傳入的數據，但清除 Id 和 OrderId
        const copiedData = { ...props.order, Id: '', OrderId: '',  Modified: '', Date: '', Paid: '', Arrived: ''};
        Object.assign(form, copiedData);
      } else {
        // 更新操作，直接使用傳入的數據
        Object.assign(form, props.order);
      }

      // Check if Customer contains "自己" or "我"
      const customerName = form.Customer?.toLowerCase() || '';
      const personalKeywords = ['自己', '我'];
      personalUseChecked.value = personalKeywords.some(keyword => customerName.includes(keyword));
    };

    const onCustomerFocus = () => {
      emit('fetchAutoCompleteData');
    };

    const onAddrFocus = () => {
      emit('fetchAutoCompleteData');
    };

    const MAX_CACHE_SIZE = 50; // 設置最大緩存項目數

    const addToCache = (keyword, results) => {
      if (Object.keys(searchCache.value).length >= MAX_CACHE_SIZE) {
        // 如果緩存已滿，刪除最舊的項目
        const oldestKey = Object.keys(searchCache.value)[0];
        delete searchCache.value[oldestKey];
      }
      searchCache.value[keyword] = results;
    };

    const searchStores = async (keyword) => {
      if (!keyword.trim()) {
        storeSearchResults.value = [];
        return;
      }

      if (searchCache.value[keyword]) {
        storeSearchResults.value = searchCache.value[keyword];
        return;
      }

      try {
        const response = await axios.get(`${api_url}/v1/stores/search`, {
          params: { keyword },
          headers: { 
            Authorization: `Bearer ${await liff.getAccessToken()}`,
            "ngrok-skip-browser-warning": "69420"
          }
        });
        storeSearchResults.value = response.data.results;
        addToCache(keyword, response.data.results);
      } catch (error) {
        console.error('Error searching stores:', error);
      }
    };

    const debouncedSearchStores = debounce(searchStores, 500);

    const handleStoreSelected = (selectedStoreName) => {
      const selectedStore = storeSearchResults.value.find(store => store.store_name === selectedStoreName);
      if (selectedStore) {
        form.Provider = selectedStore.store_name;
        const ibvValue = parseFloat(selectedStore.ibv.replace('%', ''));
        if (!isNaN(ibvValue)) {
          displayedIBVPercent.value = ibvValue;
        }
        // 保存 cashback 和 cb_ibv 資訊
        selectedStoreCashback.value = {
          cashback: selectedStore.cashback,
          cb_ibv: selectedStore.cb_ibv
        };
      }
    };

    const handleStoreInput = (inputValue) => {
      form.Provider = inputValue;
      // 清空商店現金回饋資訊，因為用戶可能在手動輸入新商店
      // 只有通過 handleStoreSelected 選擇商店時才會重新設定
      selectedStoreCashback.value = { cashback: null, cb_ibv: null };
      debouncedSearchStores(inputValue);
    };

    const onProviderFocus = () => {
      // Add any logic needed when Provider input gets focus
    };

    const timeout = ref(null);

    const displayedIBVPercent = computed({
      get: () => form.IBVPercent === 0 ? "" : Number((form.IBVPercent * 100).toFixed(4)),
      set: (value) => {
        clearTimeout(timeout.value);
        timeout.value = setTimeout(() => {
          form.IBVPercent = Number((value / 100).toFixed(4));
        }, 500);
      }
    });

    // 計算實際現金回饋金額
    const calculatedCashbackAmount = computed(() => {
      if (!selectedStoreCashback.value.cashback || !form.Total) return null;
      const cashbackPercent = parseFloat(selectedStoreCashback.value.cashback.replace('%', ''));
      const total = parseFloat(form.Total);
      if (isNaN(cashbackPercent) || isNaN(total)) return null;
      // 現金回饋是台幣金額，不需要換算匯率
      const result = total * (cashbackPercent / 100);
      return parseFloat(result.toFixed(2));
    });

    // 計算實際 IBV 點數回饋
    const calculatedCbIbvAmount = computed(() => {
      if (!selectedStoreCashback.value.cb_ibv || !form.Total || !usdPrice.value) return null;
      const cbIbvPercent = parseFloat(selectedStoreCashback.value.cb_ibv.replace('%', ''));
      const total = parseFloat(form.Total);
      if (isNaN(cbIbvPercent) || isNaN(total)) return null;
      // 與 IBV 邏輯一致：金額 * 百分比 / 100 / 美金匯率
      const result = total * (cbIbvPercent / 100) / usdPrice.value;
      return parseFloat(result.toFixed(2));
    });

    const fetchPostalCode = debounce(async (address) => {
      let processedAddress = address;
      let originalPrefix = '';

      const match = address.match(/^(\d+)\s*(.*)/);
      if (match) {
        originalPrefix = match[1];
        processedAddress = match[2].trim();
      }

      if (processedAddress.length >= 6) {
        try {
          const baseURL = `${api_url}/v1/fetch-postal-code`;
          const response = await axios.post(baseURL, null, {
            headers: {
              "ngrok-skip-browser-warning": "69420"
            },
            params: { address: processedAddress }
          });
          if (response.status === 200) {
            if (response.data !== null && response.data !== undefined) {
              form.Addr = response.data;
              nextTick(() => {
                const inputElement = autoComplete.value.inputRef;
                inputElement.classList.add('highlight-animation');
                setTimeout(() => {
                  inputElement.classList.remove('highlight-animation');
                }, 2000);
                autoComplete.value.focusAndSelect(form.Addr.length, form.Addr.length);
              });
            } else {
              form.Addr = originalPrefix + processedAddress;
            }
          } else {
            form.Addr = originalPrefix + processedAddress;
          }
        } catch (error) {
          console.error('Error fetching postal code:', error);
          form.Addr = originalPrefix + processedAddress;
        }
      }
    }, 2000);

    return {
      form,
      cancel,
      openModal,
      closeModal,
      orderModalRef,
      handleAdd,
      handleUpdate,
      handleDel,
      confirmModalRef,
      usdPrice,
      handleSelected,
      handleInput,
      handleCustomerSelected,
      handleCustomerInput,
      autoFill,
      updateAutoCompleteValue,
      orderModalType,
      isReadOnly,
      adjustTextareaHeight,
      itemTextarea,
      onCustomerFocus,
      onAddrFocus,
      storeSearchResults,
      handleStoreSelected,
      handleStoreInput,
      onProviderFocus,
      displayedIBVPercent,
      timeout,
      autoComplete,
      customerAutoComplete,
      shouldAutoFillOnContactsUpdate,
      personalUseChecked,
      selectedStoreCashback,
      calculatedCashbackAmount,
      calculatedCbIbvAmount,
      isLabUser,
      checkLabAccess
    };
  },
  data () {
    return {
      isLoading: false,
      modal: null,
      timeout: null
    }
  },
  computed: {
    paidChecked: {
      get() {
        // 只要不是空字串或 null 或含有'未'，就回傳 true
        return this.form.Paid && this.form.Paid.trim() !== '' && !this.form.Paid.includes('未');
      },
      set(value) {
        // 當 checkbox 被勾選或取消勾選時，根據需要更新 variable 的值
        if (value) {
          // 如果 checkbox 被勾選，直接設定新值
          this.form.Paid = '已付款';
        } else {
          // 如果 checkbox 被取消勾選，則將 variable 設置為空字串或其它表示未選擇的值
          this.form.Paid = '';
        }
      }
    },
    arrivedChecked: {
      get() {
        // 只要不是空字串或 null 或含有'未'，就回傳 true
        return this.form.Arrived && this.form.Arrived.trim() !== '' && !this.form.Arrived.includes('未');
      },
      set(value) {
        // 當 checkbox 被勾選或取消勾選時，根據需要更新 variable 的值
        if (value) {
          // 如果 checkbox 被勾選，直接設定新值
          this.form.Arrived = '已到貨';
        } else {
          // 如果 checkbox 被取消勾選，則將 variable 設置為空字串或其它表示未選擇的值
          this.form.Arrived = '';
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.auto-expand {
  min-height: 38px;
  overflow-y: hidden;
  resize: none;
  transition: height 0.1s ease-out;
}

.modal-dialog-scrollable {
  height: 100%;
  @media (min-width: 576px) {
    max-width:640px;
  }
}

.p-2px {
  padding: 2px;
}

// switch
.form-switch .form-check-input {
  width: 2.5em;
  height: 22px;
  border: 0;
  background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 1%29%27/%3e%3c/svg%3e");
  &:not(:checked) {border-color: #ced4da;background-color: #ced4da;}
}

.percentage-form,.checked-form {
  position: relative;
  input {
    padding-right: 2rem!important;
  }
  span {
    position: absolute;
    bottom: 0; right: 0;
    height: 2rem; width: 2rem;
    padding-bottom: 0.625rem;
    display: flex;
    align-items: center; justify-content: center;
  }
}

</style>